/**
 * Redirect.jsx
 * URL: /redirect/?url-path=xxxx&other_flags1=xxxx&otherflags2=xxxx
 * url-path = everything after url-path= to end of query string.
 * Other params → OLAP logger server-side. Immediate redirect, no render.
 */

import { useEffect, useMemo } from 'react';

const getUrlPath = () => {
  const query = window.location.search.slice(1); // strip leading ?
  if (!query) return null;

  const paramPrefix = 'url-path=';
  const start = query.indexOf(paramPrefix);
  if (start === -1) return null;

  // Value spans everything after "url-path=" to end of query string
  return query.slice(start + paramPrefix.length);
};

const RedirectPage = () => {
  const urlPath = useMemo(getUrlPath, []);

  useEffect(() => {
    if (urlPath) {
      window.location.href = urlPath;
    } else {
      window.location.href = '/';
    }
  }, [urlPath]);

  return null;
};

export default RedirectPage;